module.exports = __webpack_public_path__ + "img/cancel.9203f266.png";